import React from 'react';
import PropTypes from 'prop-types';
import { MuteSVG, VolumeLoudSVG, VolumeSVG } from '../../assets';
var VolumeSVGHelper = function VolumeSVGHelper(_ref) {
  var isMuted = _ref.isMuted,
    localVolume = _ref.localVolume;
  if (isMuted) return /*#__PURE__*/React.createElement(MuteSVG, null);
  if (parseFloat(localVolume) >= 0.5) {
    return /*#__PURE__*/React.createElement(VolumeLoudSVG, null);
  }
  return /*#__PURE__*/React.createElement(VolumeSVG, null);
};
VolumeSVGHelper.propTypes = {
  isMuted: PropTypes.bool.isRequired,
  localVolume: PropTypes.string.isRequired
};
export default VolumeSVGHelper;